import { LoyaltyUserJourney } from 'pages/loyalty/loyalty-user-journey/loyalty-user-journey';

export default function ChallengeUserJourney() {
  return <LoyaltyUserJourney />;
}
